module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9585.c0b334ec.jpg";